/**
 * CreateAccountForm.jsx
 * Created by michaelbray on 2/13/18.
 */

import React from 'react';
import PropTypes from 'prop-types';
import * as Icons from '../../../sharedComponents/icons/Icons';
import NotificationsWrapper from '../../../notifications/NotificationsWrapper';

const propTypes = {
    disableAccountFeatures: PropTypes.bool,
    errorText: PropTypes.string,
    signIn: PropTypes.func,
    confirmAccount: PropTypes.func
};

export default class CreateAccountForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: '',
            lastName: '',
            email: ''
        };

        this.firstNameTextChange = this.firstNameTextChange.bind(this);
        this.lastNameTextChange = this.lastNameTextChange.bind(this);
        this.emailTextChange = this.emailTextChange.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    componentDidMount() {
        this.firstName.focus();
    }

    firstNameTextChange(e) {
        this.setState({
            firstName: e.target.value
        });
    }

    lastNameTextChange(e) {
        this.setState({
            lastName: e.target.value
        });
    }

    emailTextChange(e) {
        this.setState({
            email: e.target.value
        });
    }

    submitForm(e) {
        e.preventDefault();

        this.props.confirmAccount({
            email: this.state.email,
            firstName: this.state.firstName,
            lastName: this.state.lastName
        });
    }

    render() {
        let error = null;

        if (this.props.errorText) {
            error = (
                <div className="rec-notification-error">
                    <span className="rec-notification-icon">
                        <Icons.IconWarning />
                    </span>
                    <div className="rec-notification-body">
                        <p>{this.props.errorText}</p>
                    </div>
                </div>
            );
        }

        let signUpDisabled = null;
        if (this.props.disableAccountFeatures) {
            signUpDisabled = (
                <NotificationsWrapper noticeType="error" closeButton={false}>
                    <div className="rec-notification-title">This is a BETA site. Please be aware
                        that you cannot make or change any reservations in this BETA version of
                        the site, nor can you log in to your account or create a new one.
                    </div>
                </NotificationsWrapper>
            );
        }

        return (
            <div>
                <div className="rec-modal-title">Create an Account</div>
                {signUpDisabled}
                {error}
                <form onSubmit={this.submitForm}>
                    <div className="form-item-wrap">
                        <label
                            htmlFor="rec-acct-first"
                            className="rec-sr-only">
                            First Name
                        </label>
                        <input
                            disabled={this.props.disableAccountFeatures}
                            ref={(firstName) => this.firstName = firstName}
                            onChange={(event) => this.firstNameTextChange(event)}
                            placeholder="First Name"
                            id="rec-acct-first"
                            className="rec-acct-first" />
                        <div className="form-item-icon-holder">
                            <Icons.IconPerson className="rec-icon-person" />
                        </div>
                    </div>
                    <div className="form-item-wrap">
                        <label
                            htmlFor="rec-acct-last"
                            className="rec-sr-only">
                            Last Name
                        </label>
                        <input
                            disabled={this.props.disableAccountFeatures}
                            ref={(lastName) => this.lastName = lastName}
                            onChange={(event) => this.lastNameTextChange(event)}
                            placeholder="Last Name"
                            id="rec-acct-last"
                            className="rec-acct-last" />
                        <div className="form-item-icon-holder">
                            <Icons.IconPerson className="rec-icon-person" />
                        </div>
                    </div>
                    <div className="form-item-wrap">
                        <label
                            htmlFor="rec-acct-email"
                            className="rec-sr-only">
                            Email Address
                        </label>
                        <input
                            disabled={this.props.disableAccountFeatures}
                            ref={(email) => this.email = email}
                            onChange={(event) => this.emailTextChange(event)}
                            placeholder="Email Address"
                            id="rec-acct-email"
                            className="rec-acct-email" />
                        <div className="form-item-icon-holder">
                            <Icons.IconEmail className="rec-icon-email" />
                        </div>
                    </div>
                    <button
                        disabled={this.props.disableAccountFeatures}
                        className="rec-button-primary"
                        title="Create an Account"
                        aria-label="Create an Account">
                        Create an Account
                    </button>
                </form>
                <p className="text-small">By creating an account, I accept Recreation.gov&#39;s&nbsp;<a href='/disclaimers'>Terms of Use</a> and <a href='/privacy-policy'>Privacy Policy</a>
                </p>
                <div className="rec-acct-modal-footer">
                    <p>Already have a Recreation.gov account?</p>
                    <button
                        disabled={this.props.disableAccountFeatures}
                        onClick={this.props.signIn}
                        className="rec-button-link"
                        title="Log In"
                        aria-label="Log In">
                        Log In
                    </button>
                </div>
            </div>
        );
    }
}

CreateAccountForm.propTypes = propTypes;
